export default "__VITE_ASSET__582df780__"